/* eslint-disable no-new-object */
/**
 * Valida los horarios seleccionados.
 * @param {Object} Horarios - Objeto que contiene los horarios seleccionados.
 * @throws {Error} Se lanzará un error si no se selecciona ningún horario.
 * @throws {Error} Se lanzará un error si algún horario seleccionado no es un objeto.
 */
export const validateHorarios = (type, Horarios = {}) => {
  const o = new Object(Horarios);
  if (type.laboratorio != null) {
    if (
      !o.hasOwnProperty("laboratorio") ||
      !(o["laboratorio"] instanceof Date)
    ) {
      throw new Error("Selecciona un horario válido para laboratorio");
    }
  }

  if (type.radiologia != null) {
    if (!o.hasOwnProperty("radiologia") || !(o["radiologia"] instanceof Date)) {
      throw new Error("Selecciona un horario valido para radiología");
    }
  }

  if (type.operador != null) {
    if (!o.hasOwnProperty("operador") || !(o["operador"] instanceof Date)) {
      throw new Error(
        "Selecciona un horario valido para el servicio de operador",
      );
    }
  }

  if (!Horarios?.radiologia && !Horarios?.laboratorio && !Horarios?.operador) {
    throw new Error("Selecciona uno o más horarios.");
  }
};

/**
 * Valida la dirección proporcionada.
 * @param {Object} Direccion - Objeto que contiene la dirección.
 * @throws {Error} Se lanzará un error si no se proporciona un código postal.
 * @throws {Error} Se lanzará un error si no se proporciona una ciudad.
 * @throws {Error} Se lanzará un error si no se proporciona una calle.
 * @throws {Error} Se lanzará un error si el código postal no tiene 5 dígitos.
 * @throws {Error} Se lanzará un error si no se proporciona un número exterior.
 * @throws {Error} Se lanzará un error si no se proporciona una referencia.
 */
export const validateDireccion = (Direccion = {}) => {
  if (!Direccion.cp) {
    throw new Error("Código postal no válido");
  }
  if (!Direccion?.ciudad) {
    throw new Error("Selecciona una colonia");
  }
  if (!Direccion?.calle) {
    throw new Error("Especifica una calle.");
  }
  if (Direccion?.cp?.length !== 5) {
    throw new Error("Verifica el código postal");
  }
  if (!Direccion?.numeroExt) {
    throw new Error("Selecciona un número exterior");
  }
  if (!Direccion?.referencia) {
    throw new Error("Inserte una referencia");
  }
  if (Direccion.linkGoogleMap) {
    const googleMapsRegex =
      /^(https?:\/\/)?(www\.)?(google\.com\/maps|maps\.google\.com|goo\.gl\/maps)/i;
    if (!googleMapsRegex.test(Direccion.linkGoogleMap)) {
      throw new Error("El link de Google Maps no es válido");
    }
  }
};

/**
 * Valida los datos del usuario.
 * @param {Object} usuario - Objeto que contiene los datos del usuario.
 * @throws {Error} Se lanzará un error si no se proporciona un nombre de usuario.
 * @throws {Error} Se lanzará un error si no se proporciona un número de teléfono.
 * @throws {Error} Se lanzará un error si el número de teléfono no tiene 10 dígitos.
 */
export const validateUsuario = (usuario) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/i;
  if (!usuario?.nombre) {
    throw new Error(
      "El nombre del cliente es importante, ¡No olvides agregarlo!.",
    );
  }
  if (!usuario?.telefono) {
    throw new Error("El teléfono es obligatorio");
  }

  if (usuario?.telefono?.length !== 10) {
    throw new Error("El número de telefono debe contener 10 dígitos");
  }
  // if (!usuario?.correo) {
  //   throw new Error("Recuerda ingresar el correo electrónico");
  // }
  if (usuario?.correo && !usuario?.correo.match(regex)) {
    throw new Error("El formato de correo electrónico no es válido");
  }
};

/**
 * Valida los artículos de una orden.
 * @param {Array} Orden - Array que contiene los artículos de la orden.
 * @throws {Error} Se lanzará un error si no se agregan artículos a la orden.
 */
export const validateOrder = (Orden = []) => {
  if (!Orden.length) {
    throw new Error(" ¡Olvidas agregar articulos!, selecciona alguno");
  }
};

/**
 * Valida el método de pago seleccionado.
 * @param {string} value - Método de pago seleccionado.
 * @throws {Error} Se lanzará un error si no se especifica un método de pago.
 */
export const validatePayment = (value) => {
  if (!value) {
    throw new Error("Especifica un método de pago");
  }
};
